export default "__VITE_ASSET__DYJKwzBV__"